import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";  
import usePrescriberNetworks from "./hooks/usePrescriberNetworks";  

// PrescriberNetworks 
const PrescriberNetworks = () => {  
  const prescriberNetworksData = usePrescriberNetworks();  
  return (  
    <div class="container container-fluid"> 
      <ButtonsSection ctaButtons={prescriberNetworksData.leftButtons} align="left" />  
      <div className="header-section">  
        <h1>  
          {prescriberNetworksData.screen_title} -{" "}  
          <span className="heading-cod">{prescriberNetworksData.screenNumber}</span>  
        </h1>  
      </div>  
      <SearchBox  
        formFields={prescriberNetworksData.formFields}  
        dropdownValues={prescriberNetworksData.dropdownValues}  
        paramsData={prescriberNetworksData.paramsData}  
        updataParamData={prescriberNetworksData.updateParamData}  
      />  
      <ButtonsSection ctaButtons={prescriberNetworksData.ctaButtons} />  
      <DisplayTable  
        data={prescriberNetworksData.data}  
        parmKey={prescriberNetworksData.parmKey}  
        menuOptions={prescriberNetworksData.menuOptions}  
        tableHeaders={prescriberNetworksData.columnDef}  
        setRowData={prescriberNetworksData.setRowData}  
        selectedPriceSchedules={prescriberNetworksData.selectedRows}  
        setSelectedPriceSchedules={prescriberNetworksData.setSelectedRows}  
      />  
      <div className="paginator-container">  
        <NextGenPaginator  
          first={prescriberNetworksData.first}  
          rows={prescriberNetworksData.rows}  
          totalRecords={prescriberNetworksData.totalRecords}  
          currentPage={prescriberNetworksData.currentPage}  
          rowsPerPageOptions={[10, 25, 50]}  
          onPageChange={prescriberNetworksData.onPageChange}  
        />  
      </div>  
      {prescriberNetworksData.isConfirmationModalOpen && (  
        <ConfirmationModal  
          isOpen={prescriberNetworksData.isConfirmationModalOpen}  
          onRequestClose={prescriberNetworksData.closeConfirmationModal}  
          onBack={prescriberNetworksData.closeConfirmationModal}  
          onSave={prescriberNetworksData.deletePrescriberNetworks}  
          confirmLabel="Confirm(Y/N)"  
          options={[  
            { label: "N-No", value: "no" },  
            { label: "Y-Yes", value: "yes" },  
          ]}  
          setSelectedOption={prescriberNetworksData.setSelectedOption}  
        />  
      )}  
    </div>  
  );  
};  
  
export default PrescriberNetworks;  
